module.exports = __webpack_public_path__ + "img/sz.1238f45f.svg";